import gql from "graphql-tag"

export const interestFieldsFragment = gql`
  fragment interestFields on Interest {
    id
    etag
    contentId
    questionGroups
  }
`
